<template>
  <div class="b-cinema-overlay">
    <div class="b-cinema-overlay__layout">
      <div class="b-cinema-overlay__container">
        <div class="b-cinema-overlay__title-container">
          {{ title }}
        </div>
        <div class="b-cinema-overlay__options-container">
          <button
            v-for="(cinema, index) in cinemas"
            :key="index"
            type="button"
            class="b-cinema-overlay__holder"
            :disabled="isDisabled(cinema)"
            @click="chooseCinema(cinema)">
            <div class="b-cinema-overlay__holder__name">
              {{ cinema.display }}
            </div>
            <div
              class="b-cinema-overlay__holder__address"
              v-html="cinema.address"></div>
          </button>
        </div>
      </div>
    </div>
    <div v-if="!desktop" class="form-floating">
      <select class="form-select" @change="selectCinema">
        <option value="" selected disabled>{{ label }}</option>
        <option
          v-for="cinema in cinemas"
          :key="cinema.value"
          :value="cinema.value"
          :disabled="isDisabled(cinema)">
          {{ cinema.display }}
        </option>
      </select>

      <label for="genre" class="form-label">
        {{ placeholder }}
      </label>
    </div>
  </div>
</template>

<script setup>
import useViewport from '../../features/viewport'
const { desktop } = useViewport()

const props = defineProps({
  title: { default: '', type: String },
  cinemas: {
    default() {
      return []
    },
    type: Array,
  },
  placeholder: {
    default: '',
    type: String,
  },
  label: {
    default: '',
    type: String,
  },
})

const emit = defineEmits(['choose-cinema'])

const chooseCinema = (cinema) => {
  emit('choose-cinema', cinema)
}

const selectCinema = (e) => {
  const cinemaData = props.cinemas.find((item) => item.value === e.target.value)
  chooseCinema(cinemaData)
}

const isDisabled = (entry) => {
  return !entry.isOnline
}
</script>
